import React from "react";
import { Avatar } from "@mui/material";

const user = {
  avatar1: "/static/images/avatars/zippy.png",
  name: localStorage.getItem("user"),
  email: localStorage.getItem("email"),
  group: localStorage.getItem("group"),
};

function ImageUpload() {
  const [avatar, setAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgimage/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleClick = () => {
    let group_name = localStorage.getItem("group");
    if (group_name == "trainee"){
      window.location.href = "/app/runninglabs";
    }
    else{
      window.location.href = "/app/dashboard";
    }
  };

  return (
    <>
      <Avatar
        src={avatar ? avatar.cover : ""}
        sx={{
          cursor: "pointer",
          width: 100,
          height: 30,
        }}
        style={{ borderRadius: 0 }}
        onClick={handleClick}
      />
    </>
  );
}

export default ImageUpload;
